export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9067.66da1e09.jpg";